/* DEMO (29 Oct): puts the 'Shop Top Categories' section on the homepage straight under Our Best Sellers (or under the slideshow if there is no best sellers row). The old Browse by Category grid is hidden by CSS. */
(function () {
  'use strict';
  var tries = 0;
  function place() {
    var tpl = document.getElementById('dc-cats-tpl');
    if (!tpl || document.getElementById('dc-cats')) return;
    var anchor = document.getElementById('dc-popular');
    if (!anchor && tries < 20) { tries++; return setTimeout(place, 50); }
    anchor = anchor || document.getElementById('dc-hero') || document.getElementById('masthead');
    if (!anchor || !anchor.parentNode) return;
    anchor.parentNode.insertBefore(tpl.content.firstElementChild.cloneNode(true), anchor.nextSibling);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', place); else place();
})();